/**
 * ActionButton — RBAC-gated button with pre-configured variants for common actions.
 * Use this for all CRUD action buttons across the application.
 */
import React from 'react';
import { Button, type ButtonProps } from '../primitives/Button';
import { useAuth } from '@/context/useAuth';
import { hasPermission } from '@/utils/permissions';

export interface ActionButtonProps extends ButtonProps {
  /** Required: the permission string that gates this action */
  permission: string;
  /** Action type for automatic icon + variant defaults */
  actionType?: 'create' | 'edit' | 'delete' | 'export' | 'import' | 'refresh' | 'custom';
}

export const ActionButton: React.FC<ActionButtonProps> = ({ permission, actionType, variant, ...props }) => {
  const { user } = useAuth();

  if (!hasPermission(user, permission)) return null;

  const effectiveVariant = variant || (actionType === 'delete' ? 'danger' : actionType === 'export' ? 'outline' : 'primary');

  return <Button variant={effectiveVariant} {...props} />;
};
export default ActionButton;
